import type { PriorityI, PriorityFilterI } from 'types';
import { BaseApi } from './base-api';

class PrioritiesApi extends BaseApi<PriorityI, PriorityFilterI> {}

export const prioritiesApi = new PrioritiesApi('/priorities');

export default prioritiesApi;
